import { BaseAdoptableBuyerElementGroup } from '../../sharedBases/adoptableBuyer';
import type { BaseAdoptableSellerElementGroup } from '../../sharedBases/adoptableSeller';
import type { ElementPlacementMap, ElementGroup } from '../../types';

export enum StashDeviationElementPlacement {
  /**
   * Where all the action happens. The bar directly under the deviation
   */
  PrimaryBar = 'primary-bar',

  /**
   * Collapsed into the primary bar's more actions menu
   */
  PrimaryBarMenu = 'primary-bar-menu',

  /**
   * Completely excluded. Nothing. Nowhere.
   */
  NotIncluded = 'not-included',
}

export const NOT_INCLUDED_VISIBILITY_GROUP: ElementGroup<StashDeviationElementPlacement> =
  {
    groupPlacement: StashDeviationElementPlacement.NotIncluded,
    countOnBar: 0,
  };

export type StashElementPlacementAll = StashDeviationElementPlacement;

export type StashElementPlacementPrimaryBarOnly =
  | StashDeviationElementPlacement.PrimaryBar
  | StashDeviationElementPlacement.NotIncluded;

export type StashElementPlacementPrimaryMenuOnly =
  | StashDeviationElementPlacement.PrimaryBarMenu
  | StashDeviationElementPlacement.NotIncluded;

/**
 * @see BaseAdoptableBuyerElementGroup
 */
export type StashAdoptableBuyerElementGroup = BaseAdoptableBuyerElementGroup<
  StashDeviationElementPlacement,
  StashElementPlacementPrimaryBarOnly
>;

/**
 * @see BaseAdoptableSellerElementGroup
 */
export type StashAdoptableSellerElementGroup = BaseAdoptableSellerElementGroup<
  StashDeviationElementPlacement,
  StashElementPlacementPrimaryBarOnly
>;

/**
 * All possible elements of our stash actionbar, each mapped to their {@link StashDeviationElementPlacement}.
 * (e.g. is it on the bar? collapsed into the more menu? completely absent?)
 */
export type StashDeviationElementPlacementMap = ElementPlacementMap<
  StashDeviationElementPlacement,
  {
    copyLink: StashElementPlacementAll;
    sellDeviation: StashElementPlacementPrimaryBarOnly;
    editDeviation: StashElementPlacementPrimaryBarOnly;
    deleteDeviation: StashElementPlacementPrimaryMenuOnly;
    premiumDownload: StashElementPlacementPrimaryBarOnly;
    freeDownload: StashElementPlacementAll;
    muroImport: StashElementPlacementPrimaryMenuOnly;
    muroOpen: StashElementPlacementPrimaryMenuOnly;
  },
  {
    adoptableBuyer: StashAdoptableSellerElementGroup;
    adoptableSeller: StashAdoptableBuyerElementGroup;
  },
  {
    /**
     * Whether there is anything in the map with placement set to {@link StashDeviationElementPlacement.PrimaryBarMenu}.
     *
     * We could force the consumer to loop through the map and figure it out themselves, but we need to know this in multiple places.
     * Since this data is already present inside the {@link StashDeviationElementPlacementMap}, it feels squarely within its domain of responsibility.
     */
    hasPrimaryMoreActionsMenu: boolean;
  }
>;
